import { SelectOptionT } from "../models/models";
import { buildManagePageQueryString } from "./helpers/buildManagePageQueryString";
import { jumboMediaAPI } from "./service";
import { CACHE_TTL } from "./cacheConfig";

export const advertiserAPI = jumboMediaAPI.injectEndpoints({
    endpoints: (build) => ({
        getAdvertisers: build.query({
            query: (body) => `/api/AdCompanies/DataTablesSource${buildManagePageQueryString(body.columns, body.page, body.searchTerm, (body.page - 1) * body.limit, body.limit, body.orderColumnIndex, body.isDescSortDir)}`,
            providesTags: ['Advertiser'],
        }),
        getAllAdvertisers: build.query<SelectOptionT[], { asSelectOptions: boolean, value?: string }>({
            query: (body) => ({
                url: `/api/AdCompanies/UserGetWithValue?value=${body?.value || ''}`,
                responseHandler: (res: any) => res.json().then((res: any) => {
                    if (body?.asSelectOptions) {
                        return res.map((item: any) => ({ value: item.Id, label: item.Name }))
                    } else {
                        return res;
                        // .map((item: any) => ({ id: item.Id, name: item.Name }))
                    }
                }),
            }),
            // providesTags was previously nested inside the query() return, where RTK
            // ignores it — so this list was silently untagged (masked by kUDF:0). Lift
            // it to the endpoint level so advertiser mutations (incl. inline +advertiser)
            // invalidate it, which is what makes caching it safe. (spec 12 / FE-5)
            providesTags: ['Advertiser'],
            keepUnusedDataFor: CACHE_TTL.LOOKUP,
        }),
        getAllAdvertisersFull: build.query<SelectOptionT[], { asSelectOptions: boolean }>({
            query: (body) => ({
                url: `/api/AdCompanies/UserGet`,
                responseHandler: (res: any) => res.json().then((res: any) => {
                    if (body?.asSelectOptions) {
                        return res.map((item: any) => ({ value: item.Id, label: item.Name }))
                    } else {
                        return res;
                        // .map((item: any) => ({ id: item.Id, name: item.Name }))
                    }
                }),
            }),
            providesTags: ['Advertiser'],
            keepUnusedDataFor: CACHE_TTL.LOOKUP,
        }),
        createAdvertiserShort: build.mutation({
            query: (body) => ({
                url: `/api/AdCompanies/UserPost`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Advertiser'],
            onQueryStarted: async () => {
                
            }
        }),
        createAdvertiser: build.mutation({
            query: (body) => ({
                url: `/api/AdCompanies/AdminPost`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Advertiser'],
        }),
        updateAdvertiser: build.mutation({
            query: (body) => {
                return {
                    url: `/api/AdCompanies/AdminPut/${body.Id}`,
                    method: 'PUT',
                    body,
                }
            },
            invalidatesTags: ['Advertiser'],
        }),
        deleteAdvertiser: build.mutation({
            query: (body) => ({
                url: `/api/AdCompanies/AdminDelete/${body.id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Advertiser'],
        }),
        getHoldingCompanies: build.query({
            query: body => ({
                url: '/api/AdCompanies/UserGetHoldingCompany',
                responseHandler: (res: any) => res.json().then((res: any) => {
                    return res.map((item: any) => ({ value: item.Id, label: item.HoldingCompany }))
                }),
            }),
        }),
        exportAdvertisersToCSV: build.query({
            query: () => ({
                url: `/api/AdCompanies/AdminExport?ts=1670309622479`
            }),
        }),
    }),
});

export const {
    useGetAdvertisersQuery,
    useCreateAdvertiserMutation,
    useDeleteAdvertiserMutation,
    useUpdateAdvertiserMutation,
    useGetAllAdvertisersQuery,
    useLazyGetAllAdvertisersQuery,
    useCreateAdvertiserShortMutation,
    useGetAllAdvertisersFullQuery,
    useGetHoldingCompaniesQuery,
    useLazyGetAllAdvertisersFullQuery,
    useLazyGetAdvertisersQuery,
    useLazyExportAdvertisersToCSVQuery,
    useExportAdvertisersToCSVQuery,
} = advertiserAPI;